import styled from '@emotion/styled';

export const StandardBannerWrapper = styled.div<{
  textColor?: string;
  backgroundColor?: string;
  bigHeading?: boolean;
  shortenHeight?: boolean;
}>`
  [class*='ContentWrapperstyle__ContentWrapper-sc'] {
    h1,
    h2,
    p {
      color: ${({ textColor }) => textColor || '#000'};
    }
    h1,
    h2 {
      ${({ bigHeading }) => bigHeading && 'font-size: 40px; line-height: 46px; font-weight: bold;'}
    }
    p {
      ${({ bigHeading }) => bigHeading && 'font-size: 24px; line-height: 24px;'}
    }
  }
  [class*='StandardBannerstyle__FullWidthContainer-sc'] {
    background-color: ${({ backgroundColor }) => backgroundColor || '#fff'};
    @media (min-width: ${({ theme }) => theme.breakpoints.lg}px) {
      ${({ shortenHeight }) =>
        shortenHeight &&
        `
          height: 300px;
          align-items: center;
      `}
    }
  }
  [class*='ImageContainerstyle__BackgroundWrapper-sc'] {
    @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
      @media (max-width: ${({ theme }) => theme.breakpoints.lg}px) {
        ${({ shortenHeight }) =>
          shortenHeight &&
          `
          height: 250px;
          align-items: center;
      `}
      }
    }
  }
`;
